import styled from "styled-components"

import { color } from "../../../atoms/colors"
import arrowDown from "../../../images/icons/arrow-down.svg"
import arrow from "../../../images/tab-arrow.svg"

export const WhatsappContainer = styled.div`
  position: relative;
  padding: 3rem 0 96px;
  background: linear-gradient(
    103.16deg,
    ${color.common.gradientBlue} -0.76%,
    ${color.oxfordBlue[900]} 52.98%
  );
  @media (max-width: 991.98px) {
    flex-direction: column-reverse;
    padding-bottom: 56px;
  }
  @media (max-width: 767.98px) {
    padding-bottom: 40px;
  }
  &.bg-sprite {
    .eyebrow {
      border: 2px solid ${color.oxfordBlue[600]} !important;
      color: ${color.oxfordBlue[600]} !important;
    }
  }
  &.bg-plum {
    .heading {
      color: ${color.common.white} !important;
    }
  }
  .container {
    max-width: 1170px !important;
    @media (max-width: 991.98px) {
      max-width: 770px !important;
    }
    @media (max-width: 767.98px) {
      max-width: 506px !important;
    }
  }
  .heading-container {
    position: relative;
    margin-bottom: 3rem;
    .whatsapp-icon {
      img {
        margin-top: -100px;
        width: 138px;
        height: 138px;
      }
      .gatsby-image-wrapper {
        margin-top: -100px;
        width: 138px;
        height: 138px;
        img {
          width: 138px;
          height: 138px;
          margin-top: unset;
        }
      }
    }
    .heading {
      text-align: center;
      color: ${color.oxfordBlue[900]};
      margin-bottom: 20px;
      letter-spacing: -0.02em;
      font-size: 36px;
      line-height: 45px;
      font-weight: 900;
      @media (max-width: 767.98px) {
        font-size: 30px;
        line-height: 38px;
      }
      @media (max-width: 575.98px) {
        font-size: 24px;
        line-height: 32px;
      }
    }
  }
  .main-section {
    display: flex;
    justify-content: space-between;
    @media (max-width: 991.98px) {
      display: block;
    }
    .nav {
      width: 50%;
      margin-right: 15px;
      border: none;
      @media (max-width: 991.98px) {
        margin-right: 0;
        width: 100%;
      }
      a {
        display: flex;
        align-items: center;
      }
      .nav-item {
        width: 100%;
        .nav-link {
          width: 100%;
          height: 100%;
          text-align: left;
          padding: 36px 48px 32px 16px;
          font-size: 18px;
          border: none;
          border-radius: 0;
          border-bottom: 1px solid ${color.secondary[600]};
          position: relative;
          &:before {
            content: "";
            background-image: url(${arrow});
            background-repeat: no-repeat;
            background-position: center right;
            display: inline-block;
            width: 18px;
            height: 16px;
            position: absolute;
            top: 50%;
            right: 25px;
            margin-top: -8px;
            @media (max-width: 991.98px) {
              background-image: url(${arrowDown});
              filter: invert(1);
            }
          }
          &:first-child {
            border-top: 1px solid ${color.secondary[600]};
          }
          &:hover {
            border: none;
            border-bottom: 1px solid ${color.secondary[600]};
            color: ${color.common.white};
            &:first-child {
              border-top: 1px solid ${color.secondary[600]};
            }
          }
          &.active {
            font-weight: 600;
            color: ${color.logoGreen[950]};
            background-color: ${color.secondary[600]};
            &:before {
              display: none;
              @media (max-width: 991.98px) {
                display: block;
                transform: rotate(180deg);
                right: 18px;
                filter: none;
              }
            }
          }
        }
      }
    }
    .tab-content {
      width: 50%;
      margin-left: 15px;
      margin-bottom: -1px;
      border-top: 1px solid ${color.secondary[600]};
      border-bottom: 1px solid ${color.secondary[600]};
      font-size: 20px;
      font-weight: 400;
      line-height: 26px;
      @media (max-width: 991.98px) {
        margin-left: 0;
        width: 100%;
      }
      .description {
        padding: 24px;
        min-height: 500px;
        font-size: 16px;
        line-height: 24px;
        h6 {
          font-size: 18px;
          font-weight: 900;
        }
        @media (max-width: 991.98px) {
          min-height: fit-content;
        }
        ul {
          padding-left: 30px;
          li {
            margin-top: 10px;
          }
        }
        a {
          text-decoration: underline;
        }
      }
    }
  }
`
